import React from 'react';

export default function Card({ children, style, padding = 32, className }) {
  return (
    <div className={className} style={{
      background: '#fff',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-md)',
      border: '1px solid var(--color-border)',
      padding,
      ...style,
    }}>
      {children}
    </div>
  );
}
